export default __webpack_public_path__ + "static/02-7b1cb842177e1693c4a6d878de8ffe37.jpg";